import { useEffect } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { UbpContextProvider } from "@/components/usage-based-pricing-calculator/src/context";
import {
    useLoadProductCatalogData,
    useIsProductCatalogDataReady
} from "@/components/usage-based-pricing-calculator/src/hooks";
import { PricingPageLayout } from "@/components/wpl/pricing/src/pricing-page-layout";
import { GlobalNav } from "@/patterns/global-nav/src";

import { CapacitySidebar } from "./components/capacity-sidebar";
import { FeatureEstimation } from "./components/feature-estimation";
import { GrowthSlider } from "./components/growth-slider";
import { IndustrySelector } from "./components/industry-selector";
import { PageHeader as UbpPageHero } from "./components/page-header";
import { SolutionPlans } from "./components/solution-plans";
import { TeamSize } from "./components/team-size";

const contentLayoutStyles = css({
    display: "flex",
    gap: "40px",
    alignItems: "flex-start",
    width: "100%",
    [media.below.md]: {
        flexDirection: "column"
    }
});

const wizardColumnStyles = css({
    flex: 1,
    minWidth: 0
});

const sidebarColumnStyles = css({
    width: "360px",
    flexShrink: 0,
    position: "sticky",
    insetBlockStart: "100px",
    [media.below.md]: {
        width: "100%",
        position: "static"
    }
});

export const UsageBasedPricingPage = () => {
    return (
        <PricingPageLayout nav={<GlobalNav productKey="usage-based-pricing" />}>
            <UbpContextProvider>
                <UsageBasedPricing />
            </UbpContextProvider>
        </PricingPageLayout>
    );
};

const UsageBasedPricing = () => {
    const loadData = useLoadProductCatalogData();

    useEffect(() => {
        void loadData();
    }, []);

    const isReady = useIsProductCatalogDataReady();

    if (!isReady) {
        return <p>Loading...</p>;
    }

    return (
        <>
            <UbpPageHero />
            <div css={contentLayoutStyles}>
                <div css={wizardColumnStyles}>
                    <IndustrySelector />
                    <TeamSize />
                    <GrowthSlider />
                    <FeatureEstimation />
                    <SolutionPlans />
                </div>
                <div css={sidebarColumnStyles}>
                    <CapacitySidebar />
                </div>
            </div>
        </>
    );
};
